import { takeEvery, all, fork, put } from "redux-saga/effects";
import { GET_BUSINESS_PAGE, SEND_MODAL_FORM } from "../constants/ActionTypes";
import { push } from "react-router-redux";
import axios from "../services/customer";
import * as actions from "../actions";

// Animations will be added after enqueue data structure on Locations data promise all

function* getBusinessPageDetails(action) {
  try {
    const response = yield axios.get(`/businesses?business_slug=${action.id}`);
    console.log("GETBUSSINESSPAGEDETAILS",response);
    
    yield put(actions.setBusinessPage(response.data));
  } catch (error) {
    if (error.message.indexOf("404") >= -1) {
      console.log("page not found");
      yield put(push("/Error404"));
    }
  }
}

export function* requestBusinessPage() {
  yield takeEvery(GET_BUSINESS_PAGE, getBusinessPageDetails);
}

function* sendMessageForm(action) {
  const { name, email, message, businessname, location } = action.payload;
  try {
    const response = yield axios.post(`/messages/`, {
      name,
      email,
      message,
      businessname,
      location,
    });
    yield put(actions.sendFormResponse());
    //
  } catch (error) {}
}

export function* requestSendForm() {
  yield takeEvery(SEND_MODAL_FORM, sendMessageForm);
}
export default function* rootSaga() {
  yield all([fork(requestBusinessPage), fork(requestSendForm)]);
}



// WEBPACK FOOTER //
// ./sagas/Business.js